import { hot } from 'react-hot-loader/root';
import Component from './staffPage-view';

export default hot(Component);
